import { IzIntegrationBaseDataProvider } from './IzIntegrationBaseDataProvider';
import { IzIntegrationWebComponentSchema } from '../types';

export class IzIntegrationNirvanaDataProvider extends IzIntegrationBaseDataProvider {
  async getDataForView(): Promise<IzIntegrationWebComponentSchema> {
    return {} as unknown as IzIntegrationWebComponentSchema;
  }
}
